module.exports = __webpack_public_path__ + "static/img/998_phase_function_Paper_PointsHejduk_Prediction.8829acc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/998_phase_function_Paper_PointsHejduk_Prediction.png
// module id = XxeB
// module chunks = 0